import React from "react";
import { Tabs, withStyles } from "@material-ui/core";

export const StyledTabs = withStyles((theme) => ({
    root: {
        height: 50,
        minHeight: "auto",
        [theme.breakpoints.down('lg')]: {
            height: 40,
            minHeight: 40
        },
        [theme.breakpoints.down('md')]: {
            height: 30,
            minHeight: 30
        },
        [theme.breakpoints.down('sm')]: {
            height: 40,
            minHeight: 40
        },
        [theme.breakpoints.down('xs')]: {
            height: 30,
            minHeight: 30
        },
    },
    indicator: {
        display: "flex",
        justifyContent: "center",
        // backgroundColor: "transparent",
        "& > span": {
            height: 4,
            alignSelf: "flex-end",
            // maxWidth: "75%",
            width: "100%",
            backgroundColor: "#304D6E",
        },
    }
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);
